import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-25" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-center justify-center p-4 text-center" }
const _hoisted_4 = {
  key: 1,
  class: "overflow-y-auto px-px"
}

import { ref, watch } from 'vue';
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionRoot,
  TransitionChild,
} from '@headlessui/vue';
import IconClose from '@/components/icons/IconClose.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    title: { default: '' },
    maxWidth: { default: 'max-w-md' },
    isWidthAuto: { type: Boolean, default: true },
    isScrollable: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: boolean, title: string, maxWidth: string, isWidthAuto: boolean, isScrollable: boolean };




const selfValue = ref(props.modelValue);

watch(() => props.modelValue, (newValue) => {
  selfValue.value = newValue;
});

function closeModal () {
  selfValue.value = false;
  emit('update:modelValue', selfValue.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    show: selfValue.value,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-10",
        onClose: closeModal
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "duration-200 ease-in",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass([
                'transform overflow-hidden rounded-2xl bg-white p-6 pt-7 text-left align-middle shadow-xl transition-all',
                __props.isWidthAuto ? 'w-auto' : 'w-full',
                __props.maxWidth,
                __props.isScrollable ? 'flex flex-col h-auto max-h-[95vh]' : null,
              ])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "absolute top-4 right-4 cursor-pointer group",
                        onClick: closeModal
                      }, [
                        _createVNode(IconClose, {
                          "class-stroke": "stroke-mcgard-gray-500 group-hover:stroke-mcgard-primary",
                          size: 10
                        })
                      ]),
                      (__props.title)
                        ? (_openBlock(), _createBlock(_unref(DialogTitle), {
                            key: 0,
                            as: "h3",
                            class: "text-lg font-medium leading-6 text-gray-900"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(__props.title), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (__props.isScrollable)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _renderSlot(_ctx.$slots, "default")
                          ]))
                        : _renderSlot(_ctx.$slots, "default", { key: 2 })
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})